module.exports = __webpack_public_path__ + "img/conversations-empty-state.a3724286.svg";